import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  Table,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import cellEditFactory from "react-bootstrap-table2-editor";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import "../../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import EnterQuantityModal from "../../../../components/EnterQuantityModal";
import UpdateQuantityModal from "../../../../components/UpdateQuantityModal";

const animatedComponents = makeAnimated();

const FinishedProductAllOrders = (props) => {
  const [receiveBtnDisabled, setReceiveBtnDisabled] = useState(false);
  const storeName = localStorage.getItem("store_name");
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    return firstDay;
  });
  const [dateTo, setDateTo] = useState();
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));

    loadAllProducts();
  }, []);

  const [isUrgent, setIsUrgent] = useState(false);
  const [remarks, setRemarks] = useState();

  const [allOrders, setAllOrders] = useState([]);
  const [allOrdersFiltered, setAllOrdersFiltered] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [received, setRecieved] = useState([]);
  const [yetToReceive, setYetToReceive] = useState([]);
  const loadAllOrders = async () => {
    const days_diff = moment(dateTo).diff(dateFrom, "days");
    if (days_diff > 30) {
      setAllOrders([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    } else if (days_diff < 0) {
      setAllOrders([]);
      showNotification("Invalid date range.", "Error");
      return false;
    }

    preloader(true);
    let date_from = moment(dateFrom).format("YYYY-MM-DD"),
      date_to = moment(dateTo).format("YYYY-MM-DD");

    let url = process.env.REACT_APP_BASEURL + "productorders/getforbranch";
    const response = await postSubmitForm(url, {
      date_from: date_from,
      date_to: date_to,
    });
    if (response && response.status === 1) {
      preloader(false);
      // let expandedRows = [];
      // response.data.map((item) => {
      //   if (item.status !== "Closed" && item.status !== "Rejected") {
      //     expandedRows.push(item._id);
      //   }
      // });
      setAllOrders(response.data);
      // setExpanded(expandedRows);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  useEffect(() => {
    if (selectedStatus) {
      if (selectedStatus === "All") {
        setAllOrdersFiltered(allOrders);
      } else {
        var data = JSON.parse(JSON.stringify(allOrders));
        setAllOrdersFiltered(
          data.filter((order) => order.status === selectedStatus),
        );
      }
    }
  }, [allOrders, selectedStatus]);

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Branch Avl. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available, row.unitLevels);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];
  const [selectedOrder, setSelectedOrder] = useState();
  const [editModal, setEditModal] = useState();
  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      text: props.t("Order Date"),
      dataField: "date_to_process",
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
      // formatter: (cell, row) => {
      //   return moment(row.date_to_process).format("DD-MM-YYYY HH:mm");
      // },
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Is Urgent?"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row) => {
        if (row.is_urgent) {
          return props.t("Yes");
        } else {
          return props.t("No");
        }
      },
      csvFormatter: (cell, row) => {
        if (row.is_urgent) {
          return props.t("Yes");
        } else {
          return props.t("No");
        }
      },
      style: { cursor: "pointer" },
    },

    {
      dataField: "status",
      text: props.t("Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "admin_remarks",
      text: props.t("Centre Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      csvExport: false,
      formatter: (cell, row) => {
        if (row.status === "Placed") {
          return (
            <span className="text-primary">
              <i
                className="bx bxs-edit font-size-15"
                title="Click to Edit"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setReceiveBtnDisabled(false);
                  setEditModal(!editModal);
                  setSelectedOrder(row);
                  setIsUrgent(row.is_urgent);
                  setProductsForOrder(row.product_details);
                  setRemarks(row.remarks);
                }}
              ></i>
            </span>
          );
        } else {
          return (
            <span className="text-primary">
              <i
                className="mdi mdi-text-box-search font-size-15"
                title="Click to View Details"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setDetailsModal(!detailsModal);
                  setSelectedOrder(row);
                  let received_products = [];
                  let to_receive_products = [];
                  row.delivery_details.map((product, index) => {
                    if (product.is_received) {
                      received_products.push(product);
                    } else {
                      product.received_quantity = product.delivered_quantity;
                      product.original_delivered_quantity =
                        product.original_delivered_quantity;
                      product.uniqueId = `${product.name}-${index}`;
                      to_receive_products.push(product);
                    }
                  });
                  setRecieved(received_products);
                  setYetToReceive(to_receive_products);
                  setReceiveBtnDisabled(false);
                }}
              ></i>
            </span>
          );
        }
      },
    },
  ];

  const handleOnExpand = (row, isExpand, rowIndex, e) => {
    if (isExpand) {
      setExpanded([...expanded, row._id]);
    } else {
      setExpanded(expanded.filter((x) => x !== row._id));
    }
  };
  const [expanded, setExpanded] = useState([]);
  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="_id"
          data={row.product_details}
          columns={columns}
          noDataIndication="No data to display."
          striped
          hover
          condensed
        />
      </div>
    ),
    expanded: expanded,
    onExpand: handleOnExpand,
  };
  const rowStyle = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8", fontWeight: "500" };
    if (row.status === "Closed") {
      style.backgroundColor = "#b8ffb9";
    } else if (row.status === "Placed") {
      style.backgroundColor = "#ffb8b8";
    } else if (row.status === "Rejected") {
      style.backgroundColor = "#f1b8ff";
    } else {
      style.backgroundColor = "#b8cdff";
    }
    return style;
  };

  const rowStyleForReceive = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8", fontWeight: "500" };
    if (row.is_new_product_added) {
      style.backgroundColor = "#90EE90";
    } else {
      style.backgroundColor = "";
    }
    return style;
  };
  const [detailsModal, setDetailsModal] = useState(false);
  const [receiveModal, setReceiveModal] = useState();
  const [selectedDeliveryDetail, setSelectedDeliveryDetail] = useState();
  //compare quantitites
  function compareQuantities(product) {
    const quantities = product.received_quantity;
    const quantitiesToCompare = product.delivered_quantity;
    const unitLevels = product.unit_levels;

    const convertedQuantities = convertToLowestUnit(unitLevels, quantities);
    const convertedQuantitiesToCompare = convertToLowestUnit(
      unitLevels,
      quantitiesToCompare,
    );

    let isPartial = false;
    if (convertedQuantities < convertedQuantitiesToCompare) {
      isPartial = true;
    }
    return isPartial;
  }
  const handleReceiveProductOrder = async (e, v) => {
    setReceiveBtnDisabled(true);
    let productorder_id = selectedOrder._id;
    let delivery_details = [];
    for (let i = 0; i < yetToReceive.length; i++) {
      delivery_details.push({
        _id: yetToReceive[i]._id,
        product_id: yetToReceive[i].product_id,
        received_quantity: yetToReceive[i].received_quantity.map(
          ({ unit, value }) => ({ unit, value }),
        ),
        original_delivered_quantity:
          yetToReceive[i].original_delivered_quantity,
        unit_levels: yetToReceive[i].unit_levels.map(({ unit, value }) => ({
          unit,
          value,
        })),
        cost_price: yetToReceive[i].cost_price,
        selling_price: yetToReceive[i].selling_price,
        batch: yetToReceive[i].batch,
        remarks: yetToReceive[i].remarks,
      });
    }
    const data_to_send = {
      productorder_id,
      delivery_details,
    };
    let isNoRemarkUpdated = false;
    for (let product of yetToReceive) {
      isNoRemarkUpdated = compareQuantities(product);
      if (isNoRemarkUpdated && product.remarks === "") {
        showNotification(
          "Enter remarks for all variances in received products.",
          "Warning",
        );
        setReceiveBtnDisabled(false);
        return;
      }
    }

    // console.log(isNoRemarkUpdated); isNoRemarkUpdated=false; return
    // if (!isNoRemarkUpdated) {
    // console.log(data_to_send);return

    let url = process.env.REACT_APP_BASEURL + "productorders/receive_by_branch";
    const response = await postSubmitForm(url, data_to_send);

    if (response && response.status === 1) {
      loadAllOrders();
      isNoRemarkUpdated = false;
      setDetailsModal(!detailsModal);
      showNotification(response.message, "Success");
    } else {
      setReceiveBtnDisabled(false);
      showNotification(response.message, "Error");
    }
    // } else {
    //   showNotification(
    //     "Enter remarks for all variances in received products.",
    //     "Error"
    //   );
    // }
  };
  const columns_received = [
    {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("order Qty."),
      dataField: "initial_order_quantity",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.initial_order_quantity);
      },
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Del. Qty."),
      dataField: "delivered_quantity",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Rec. Qty."),
      dataField: "received_quantity",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Remarks"),
      dataField: "remarks",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];

  const [editQuantityModal, setEditQuantityModal] = useState(false);
  function ReceiveFormatter(cell, row) {
    return (
      <div className="d-flex align-items-center justify-content-between">
        <span className="me-2">
          {formatUnitsForReport(row.received_quantity && row.received_quantity)}
        </span>
        {selectedOrder && selectedOrder.is_received !== true && (
          <Button
            size="sm"
            className="btn btn-success"
            onClick={() => {
              const updatedItem = {
                ...row,
                quantity: row.received_quantity.map((item, idx) => ({
                  ...item,
                  index: idx,
                  isChecked: true,
                })),
              };
              setSelectedProduct(updatedItem);
              setEditQuantityModal(true);
            }}
          >
            <i className="mdi mdi-edit"></i>
            {props.t("Edit")}
          </Button>
        )}
      </div>
    );
  }
  const columns_yet_to_receive = [
    {
      dataField: "uniqueId",
      hidden: true,
    },
    {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   text: props.t("Batch"),
    //   dataField: "batch",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },

    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      editable: false,
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("order Qty."),
      dataField: "initial_order_quantity",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.initial_order_quantity);
      },
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Del. Qty."),
      dataField: "delivered_quantity",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity);
      },
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Rec. Qty."),
      dataField: "received_quantity",
      formatter: ReceiveFormatter,
      attrs: (cell, row, rowIndex, colIndex) => {
        return { title: "Click to Edit" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      // formatter: (cell, row) => {
      //   return <>{row.sub_unit ? +row.received_quantity.in_sub_unit : 0}</>;
      // },
      editable: true,
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer", background: "#ffffaa" },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
  //#region  Update related functions

  const refForForm = useRef(null);
  const refSelectProduct = useRef(null);
  const [allProducts, setAllProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const loadAllProducts = async () => {
    let url = process.env.REACT_APP_BASEURL + "branchproducts/getforbranch";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllProducts(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [productsForOrder, setProductsForOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const handleValidUpdate = async (e, v) => {
    try {
      const object = {
        id: selectedOrder._id,
        product_details: productsForOrder,
        is_urgent: isUrgent,
        remarks: v.remarks,
      };
      setIsLoading(true);
      let url = process.env.REACT_APP_BASEURL + "productorders/update";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllOrders();
        setEditModal(!editModal);
        setRemarks();
        setProductsForOrder([]);
        setIsUrgent(false);
        setSelectedProduct();
        refSelectProduct.current.select.clearValue();
        refForForm.current.reset();

        showNotification(response.message, "Success");

        refForForm.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsLoading(false);
    }
  };
  function deleteFormatter(cell, row, rowIndex, extraData) {
    return (
      <>
        <span className="text-danger">
          <i
            className="bx bxs-trash font-size-15"
            title="Click to Delete"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let arr = extraData.filter(
                (item) => item.product_id !== row.product_id,
              );

              setProductsForOrder(arr);
            }}
          ></i>
        </span>
      </>
    );
  }
  const columns_products = [
    {
      dataField: "section",
      text: props.t("Section"),
    },
    {
      dataField: "category",
      text: props.t("Category"),
    },
    {
      dataField: "name",
      text: props.t("Name"),
      sort: true,
    },
    {
      dataField: "available",
      text: props.t("Branch Avl. Qty."),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available, row.unit_levels);
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
    },
    {
      text: props.t("Remove"),
      formatter: deleteFormatter,
      formatExtraData: productsForOrder,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];
  //#endregion Update related functions

  const handleDownload = async () => {
    const fileName = "all_finished_product_orders";
    const exportType = "xls";

    let data_to_export = allOrders;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          OrderID: v.order_id,
          Remarks: v.remarks,
          Date: moment(v.date_to_process).format("DD/MM/YYYY HH:mm"),
          IsUrgent: v.is_urgent ? "Yes" : "No",
          Status: v.status,
          CenterRemarks: v.admin_remarks,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [selectUnitModal, setSelectUnitModal] = useState(false);

  function handleCloseModal() {
    setSelectUnitModal(false);
    setSelectedRowsUnit([]);
  }

  const handleAddProduct = async (quantity) => {
    let maxLimit = convertToLowestUnit(selectedProduct.unit_levels, [
      {
        unit: selectedProduct.unit_for_max_order,
        value: selectedProduct.max_order_limit,
      },
    ]);
    let totalEntered = convertToLowestUnit(
      selectedProduct.unit_levels,
      quantity,
    );
    if (totalEntered > maxLimit) {
      showNotification(
        `can not add more than <strong> ${selectedProduct.max_order_limit + " " + selectedProduct.unit_for_max_order} </strong> `,
        "Warning",
      );
      return;
    }
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedProduct.unit_levels,
    );
    var new_array_product = JSON.parse(JSON.stringify(productsForOrder));
    const existing_product = new_array_product.filter(function (prod) {
      return prod.product_id === selectedProduct.product_id;
    });

    if (existing_product.length > 0) {
      showNotification(
        props.t("This product is already added."),
        props.t("Warning"),
      );
    } else if (selectedProduct) {
      let product_to_add = {};
      product_to_add.product_id = selectedProduct?.product_id;
      product_to_add.name = selectedProduct.name;
      product_to_add.section = selectedProduct.section;
      product_to_add.category = selectedProduct.category;
      product_to_add.brand = selectedProduct.brand;
      product_to_add.available =
        selectedProduct.available.map(({ unit, value }) => ({
          unit,
          value: parseFloat(value),
        })) || null;
      product_to_add.initial_order_quantity =
        convertedQuantity.map(({ unit, value }) => ({
          unit,
          value: parseFloat(value),
        })) || null;
      product_to_add.quantity =
        convertedQuantity.map(({ unit, value }) => ({
          unit,
          value: parseFloat(value),
        })) || null;
      product_to_add.unit_levels = selectedProduct.unit_levels.map(
        ({ unit, value }) => ({ unit, value }),
      );
      product_to_add.expiry_date = selectedProduct.expiry_date;
      product_to_add.unit_for_max_order = selectedProduct.unit_for_max_order;
      product_to_add.cost_price = selectedProduct.cost_price;
      product_to_add.selling_price = selectedProduct.selling_price;
      setProductsForOrder([...productsForOrder, product_to_add]);
      setSelectUnitModal(false);
      setSelectedProduct();
      setSelectedRowsUnit([]);
      refSelectProduct.current.select.clearValue();
    } else {
      showNotification(
        props.t("Select a product batch first."),
        props.t("Error"),
      );
    }
  };
  const handleSubmit = (quantity) => {
    let totalEntered = convertToLowestUnit(
      selectedProduct.unit_levels,
      quantity,
    );
    let totalDelivered = convertToLowestUnit(
      selectedProduct.unit_levels,
      selectedProduct.delivered_quantity,
    );
    if (totalEntered > totalDelivered) {
      showNotification("Can not receive more than delivered", "Warning");
      return;
    }
    // event.preventDefault();
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedProduct.unit_levels,
    );
    const updatedItems = yetToReceive.map((prod) => {
      if (prod._id === selectedProduct._id) {
        // return selectedItem;
        return {
          ...selectedProduct,
          received_quantity: convertedQuantity.map(({ unit, value }) => ({
            unit,
            value: +value,
          })),
        };
      }
      return prod;
    });
    setEditQuantityModal(false);
    setSelectedProduct();
    setYetToReceive(updatedItems);
  };

  function handleAddQuantity(e, v) {
    e.preventDefault();
    let arrangement_quantity = [
      {
        unit: selectedProduct.unit_for_max_order,
        value: Number(v.arrangement_quantity),
      },
    ];
    let maxLimit = convertToLowestUnit(selectedProduct.unit_levels, [
      {
        unit: selectedProduct.unit_for_max_order,
        value: selectedProduct.max_order_limit,
      },
    ]);
    let totalEntered = convertToLowestUnit(
      selectedProduct.unit_levels,
      arrangement_quantity,
    );
    if (totalEntered > maxLimit) {
      showNotification(
        `can not add more than <strong>${selectedProduct.max_order_limit + " " + selectedProduct.unit_for_max_order} </strong>`,
        "Warning",
      );
      return;
    }
    let convertedQuantity = GetUpdatedDelivered(
      arrangement_quantity,
      selectedProduct.unit_levels,
    );
    var new_array_items = JSON.parse(JSON.stringify(productsForOrder));
    const existing_item = new_array_items.filter(function (product) {
      return product.product_id === selectedProduct.product_id;
    });
    if (existing_item.length > 0) {
      showNotification(
        props.t("This product is already added."),
        props.t("Warning"),
      );
    } else if (selectedProduct) {
      let product_to_add = {};
      product_to_add.product_id = selectedProduct?.product_id;
      product_to_add.name = selectedProduct.name;
      product_to_add.category = selectedProduct.category;
      product_to_add.section = selectedProduct.section;
      product_to_add.brand = selectedProduct.brand;
      product_to_add.arrangement_quantity = arrangement_quantity;
      product_to_add.available =
        selectedProduct.available.map(({ unit, value }) => ({
          unit,
          value: parseFloat(value),
        })) || null;
      product_to_add.quantity =
        convertedQuantity.map(({ unit, value }) => ({
          unit,
          value: parseFloat(value),
        })) || null;
      product_to_add.unit_levels = selectedProduct.unit_levels.map(
        ({ unit, value }) => ({ unit, value }),
      );
      product_to_add.expiry_date = selectedProduct.expiry_date;
      product_to_add.unit_for_max_order = selectedProduct.unit_for_max_order;
      if (selectedProduct.max_order_limit > 0) {
        product_to_add.max_order_limit = selectedProduct.max_order_limit;
      }
      product_to_add.cost_price = selectedProduct.cost_price;
      product_to_add.selling_price = selectedProduct.selling_price;
      setProductsForOrder([...productsForOrder, product_to_add]);
      setSelectUnitModal(false);
      setSelectedProduct();
      setSelectedRowsUnit([]);
      refSelectProduct.current.select.clearValue();
    } else {
      showNotification(
        props.t("Select a product batch first."),
        props.t("Error"),
      );
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Finished Products")}
            title={props.t("Orders")}
            breadcrumbItem1={props.t("Finished Products")}
            breadcrumbItem2={props.t("All Orders")}
          />

          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadAllOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("All Finished Product Orders")}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="_id"
                      data={allOrdersFiltered && allOrdersFiltered}
                      columns={columns_external}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={5}></Col>
                            <Col lg={3} className="text-right">
                              <select
                                name="status"
                                className="form-control"
                                value={selectedStatus}
                                onChange={(e) => {
                                  setSelectedStatus(e.target.value);
                                }}
                              >
                                <option value="All">All</option>
                                <option value="Placed">Placed</option>
                                <option value="Approved">Approved</option>
                                <option value="Dispatched">Dispatched</option>
                                <option value="Closed">Closed</option>
                                <option value="Rejected">Rejected</option>
                              </select>
                            </Col>
                          </Row>

                          <BootstrapTable
                            striped
                            hover
                            condensed
                            expandRow={expandRow}
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  {/* ---Update Modal Start--- */}
                  <Modal
                    size="xl"
                    isOpen={editModal}
                    toggle={() => setEditModal(!editModal)}
                    onClosed={() => {
                      setSelectedProduct();
                      setSelectedRowsUnit();
                    }}
                  >
                    <ModalHeader toggle={() => setEditModal(!editModal)}>
                      {props.t("Update Order - ")}
                      {selectedOrder?.order_id}
                    </ModalHeader>
                    <ModalBody>
                      {selectedOrder && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <AvForm
                                    // onValidSubmit={()=>setSelectUnitModal(!selectUnitModal)}
                                    onValidSubmit={handleAddQuantity}
                                    ref={refForForm}
                                  >
                                    <Row>
                                      <Col lg={6} md={6}>
                                        <Label>{props.t("Product")}</Label>
                                        <Select
                                          ref={refSelectProduct}
                                          value={selectedProduct}
                                          onChange={(selected) => {
                                            setSelectedProduct(selected);
                                          }}
                                          options={allProducts}
                                          classNamePrefix="select2-selection"
                                          components={animatedComponents}
                                          required
                                        />
                                      </Col>
                                      {selectedProduct && (
                                        <>
                                          <Col lg={4} md={4}>
                                            <br />
                                            <p>
                                              <Label>
                                                Central Kitchen Avl.
                                              </Label>{" "}
                                              -&nbsp;
                                              {formatUnitsForReport(
                                                selectedProduct.central_kitchen_available,
                                                selectedProduct?.unit_levels,
                                              )}
                                              <hr
                                                style={{
                                                  marginBottom: "5px",
                                                  marginTop: "-5px",
                                                }}
                                              />
                                              <Label>
                                                {storeName} Avl. -&nbsp;{" "}
                                              </Label>
                                              {formatUnitsForReport(
                                                selectedProduct.available,
                                                selectedProduct?.unit_levels,
                                              )}
                                            </p>
                                          </Col>
                                          <Col lg={2} md={2}>
                                            <br />
                                            <Label>Threshold Quantity</Label>
                                            <br />
                                            <Label>
                                              {selectedProduct.threshold +
                                                " " +
                                                selectedProduct.unit_for_threshold}
                                            </Label>
                                          </Col>
                                          <Col lg={4} md={4}>
                                            <Label>
                                              {props.t("Qty.")} in{" "}
                                              {`${selectedProduct.unit_for_max_order}`}
                                            </Label>

                                            <AvField
                                              name="arrangement_quantity"
                                              placeholder={props.t(
                                                "Enter Quantity",
                                              )}
                                              type="number"
                                              min="0"
                                              step="1"
                                              validate={{
                                                required: {
                                                  value: true,
                                                  errorMessage:
                                                    "Quantity cannot be empty.",
                                                },
                                                pattern: {
                                                  value: "^[0-9]+$",
                                                  errorMessage: props.t(
                                                    "Only numbers are allowed.",
                                                  ),
                                                },
                                                max: {
                                                  value:
                                                    selectedProduct &&
                                                    selectedProduct.max_order_limit,
                                                  errorMessage:
                                                    selectedProduct &&
                                                    props.t(
                                                      "Cannot enter more than ",
                                                    ) +
                                                      selectedProduct.max_order_limit +
                                                      " " +
                                                      selectedProduct.unit_for_max_order +
                                                      ".",
                                                },
                                              }}
                                            />
                                          </Col>
                                        </>
                                      )}

                                      <Col lg={2} md={2} className="mb-4">
                                        <Label>&nbsp;</Label>
                                        <br />
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="btn btn-info waves-effect waves-light btn-sm"
                                        >
                                          <i class="bx bx-add-to-queue"></i>{" "}
                                          {props.t("Add")}
                                        </Button>
                                      </Col>
                                    </Row>
                                    {/* <Button type="submit">Submit</Button> */}
                                  </AvForm>
                                  <hr />
                                  {productsForOrder &&
                                    productsForOrder.length > 0 && (
                                      <>
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="_id"
                                          data={
                                            productsForOrder && productsForOrder
                                          }
                                          columns={columns_products}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                        <AvForm
                                          onValidSubmit={handleValidUpdate}
                                        >
                                          <Row>
                                            <Col lg={6}>
                                              <AvField
                                                name="remarks"
                                                value={remarks}
                                                onChange={(e) => {
                                                  setRemarks(e.target.value);
                                                }}
                                                label={props.t("Remarks")}
                                                placeholder={props.t(
                                                  "Enter Remarks",
                                                )}
                                                type="textarea"
                                              />
                                            </Col>
                                            <Col lg={12}>
                                              <div class="form-check">
                                                <input
                                                  type="checkbox"
                                                  name="is_urgent"
                                                  id="isUrgentCheckbox"
                                                  className="is-untouched is-pristine av-valid form-check-input"
                                                  checked={isUrgent}
                                                  onChange={(e) => {
                                                    if (e.target.checked) {
                                                      setIsUrgent(true);
                                                    } else {
                                                      setIsUrgent(false);
                                                    }
                                                  }}
                                                />
                                                <label for="isUrgentCheckbox">
                                                  {props.t(
                                                    "This is an urgent order.",
                                                  )}
                                                </label>
                                              </div>
                                            </Col>
                                            <Col lg={12}>
                                              <hr />
                                              <FormGroup className="mb-0 text-left">
                                                <div>
                                                  <Button
                                                    type="submit"
                                                    color="primary"
                                                    disabled={isLoading}
                                                    style={{ width: "150px" }}
                                                  >
                                                    {isLoading ? (
                                                      <Spinner size="sm" />
                                                    ) : (
                                                      props.t("Update Order")
                                                    )}
                                                  </Button>
                                                </div>
                                              </FormGroup>
                                            </Col>
                                          </Row>
                                        </AvForm>
                                      </>
                                    )}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                  {/* ---Update Modal End--- */}

                  {/* ---Details Modal Start--- */}
                  <Modal
                    size="lg"
                    isOpen={detailsModal}
                    toggle={() => setDetailsModal(!detailsModal)}
                  >
                    <ModalHeader toggle={() => setDetailsModal(!detailsModal)}>
                      {props.t("Order Details")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  {selectedOrder &&
                                  yetToReceive &&
                                  yetToReceive.length > 0 ? (
                                    <>
                                      <AvForm
                                        onValidSubmit={
                                          handleReceiveProductOrder
                                        }
                                      >
                                        <Col lg={12} md={12}>
                                          <br />
                                          <Label>
                                            <b>
                                              {props.t(
                                                "Dispatched Products",
                                              )}{" "}
                                            </b>
                                          </Label>
                                        </Col>
                                        <Col lg={12} className="mb-4">
                                          <BootstrapTable
                                            bootstrap4
                                            keyField="uniqueId"
                                            key="uniqueId"
                                            columns={columns_yet_to_receive}
                                            data={yetToReceive}
                                            cellEdit={cellEditFactory({
                                              mode: "click",
                                              blurToSave: true,
                                            })}
                                            noDataIndication="No data to display."
                                            striped
                                            rowStyle={rowStyleForReceive}
                                            hover
                                            condensed
                                          />
                                        </Col>
                                        <Col lg={12} className="text-center">
                                          <Label>&nbsp;</Label>
                                          <br />
                                          <Button
                                            type="submit"
                                            disabled={receiveBtnDisabled}
                                            color="primary"
                                            style={{ width: "150px" }}
                                            className="btn btn-default waves-effect waves-light"
                                          >
                                            {receiveBtnDisabled ? (
                                              <Spinner size="sm" />
                                            ) : (
                                              props.t("Receive Products")
                                            )}
                                          </Button>
                                          <hr />
                                        </Col>
                                      </AvForm>
                                    </>
                                  ) : null}
                                  <Link
                                    to="#"
                                    onClick={() => {
                                      printDiv("printOrdered");
                                    }}
                                    className="btn btn-sm btn-success mr-2"
                                  >
                                    <i className="fa fa-print"></i> Print
                                  </Link>
                                  <div id="printOrdered">
                                    <Col lg={12} md={12}>
                                      <Label>Ordered Products</Label>
                                    </Col>

                                    <Col lg={12}>
                                      <BootstrapTable
                                        bootstrap4
                                        keyField="name"
                                        data={
                                          selectedOrder &&
                                          selectedOrder.product_details
                                        }
                                        columns={columns}
                                        noDataIndication="No data to display."
                                        striped
                                        hover
                                        rowStyle={rowStyleForReceive}
                                        condensed
                                      />
                                      <hr />
                                    </Col>
                                  </div>
                                  {selectedOrder &&
                                  received &&
                                  received.length > 0 ? (
                                    <>
                                      <Col lg={12} md={12}>
                                        <br />
                                        <Label>
                                          <b>{props.t("Received Products")} </b>
                                        </Label>
                                      </Col>
                                      <Col lg={12} className="mb-4">
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          key="name"
                                          data={received}
                                          columns={columns_received}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          rowStyle={rowStyleForReceive}
                                          condensed
                                        />
                                        <hr />
                                      </Col>
                                    </>
                                  ) : null}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>
                  {/* ---Details Modal End--- */}

                  {/* ---Receive Modal Start--- */}
                  <Modal
                    size="md"
                    isOpen={receiveModal}
                    toggle={() => setReceiveModal(!receiveModal)}
                  >
                    <ModalHeader toggle={() => setReceiveModal(!receiveModal)}>
                      {props.t("Recieve Product Order")}
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <AvForm
                                onValidSubmit={(e, v) => {
                                  handleReceiveProductOrder(e, v);
                                }}
                              >
                                <Row>
                                  <Col lg={6}>
                                    <Label>{props.t("Section") + ": "}</Label>

                                    <span>
                                      {" "}
                                      {selectedDeliveryDetail &&
                                        selectedDeliveryDetail.section}
                                    </span>
                                  </Col>

                                  <Col lg={6}>
                                    <Label>{props.t("Category") + ": "}</Label>
                                    <span>
                                      {" "}
                                      {selectedDeliveryDetail &&
                                        selectedDeliveryDetail.category}
                                    </span>
                                  </Col>

                                  <Col lg={6}>
                                    <Label>{props.t("Name") + ": "}</Label>
                                    <span>
                                      {" "}
                                      {selectedDeliveryDetail &&
                                        selectedDeliveryDetail.name}
                                    </span>
                                  </Col>
                                  <Col lg={6}>
                                    <Label>
                                      {props.t("Delivered Quantity") + ": "}
                                    </Label>
                                    <span>
                                      {" "}
                                      {selectedDeliveryDetail &&
                                        selectedDeliveryDetail.delivered_quantity}
                                    </span>
                                  </Col>
                                  <Col lg={12}>
                                    <hr />
                                    <AvField
                                      name="received_quantity"
                                      label={props.t("Received Quantity")}
                                      placeholder={props.t(
                                        "Enter Received Quantity",
                                      )}
                                      type="text"
                                      errorMessage="Received quantity cannot be empty."
                                      validate={{
                                        required: { value: true },
                                        pattern: {
                                          value: "^[0-9]+$",
                                          errorMessage: props.t(
                                            "Only numbers are allowed.",
                                          ),
                                        },
                                      }}
                                    />
                                  </Col>
                                  <Col lg={12}>
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Submit")}
                                        </Button>{" "}
                                      </div>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </AvForm>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>
                  {/* ---Receive Modal End--- */}

                  {/* edit quantity modal  */}
                  <UpdateQuantityModal
                    isOpen={editQuantityModal}
                    toggle={() => setEditQuantityModal(false)}
                    onSubmit={handleSubmit}
                    item={selectedProduct}
                    noCheck={true}
                  />

                  {/* Add Quantity modal  */}
                  <EnterQuantityModal
                    isOpen={selectUnitModal}
                    toggle={handleCloseModal}
                    onSubmit={handleAddProduct}
                    item={selectedProduct}
                    checkLimitFor={"order"}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(FinishedProductAllOrders)),
);
